import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";
import Select from "react-select"; // React-select include panniyaachu

const EditDriver = () => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [form, setForm] = useState({
        id: id,
        name: "",
        phone: "",
        license_number: "",
        company_name: "",
        basic_salary: "",     
        office_hours_ot: "",  
        after_office_ot: "",  
        holiday_ot: "",       
        status: ""
    });

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
    ];

    /* ================= FETCH DRIVER DATA ================= */
    useEffect(() => {
        const fetchDriver = async () => {
            dispatch(loadingTrue());
            const res = await Handler({
                method: "get",
                url: `/driver/view.php?id=${id}` 
            });

            if (res.success && res.data && res.data.driver_info) {
                const d = res.data.driver_info; 
                setForm({
                    id: d.id,
                    name: d.name || "",
                    phone: d.phone || "",
                    license_number: d.license_number || "",
                    company_name: d.company_name || "",
                    basic_salary: d.basic_salary || "",
                    office_hours_ot: d.office_hours_ot || "",
                    after_office_ot: d.after_office_ot || "",
                    holiday_ot: d.holiday_ot || "",
                    status: d.status || "active"
                });
            } else {
                toast.error("Driver data not found");
                navigate("/drivers");
            }
            dispatch(loadingFalse());
        };
        fetchDriver();
    }, [id, dispatch, navigate]);

    /* ================= HANDLERS ================= */
    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSelectChange = (selectedOption) => {
        setForm({ ...form, status: selectedOption.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/driver/update.php",
            data: form
        });

        if (res.success) {
            toast.success(res.message || "Driver Updated Successfully");
            setTimeout(() => reloadWindowToPath("/drivers"), 1000);
        } else {
            toast.error(res.message || "Update failed");
        }
        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">
            <div className="page-header">
                <h4>Update Driver Details</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">
                {/* Basic Info */}
                <div className="form-group">
                    <label>Driver Name</label>
                    <input name="name" className="form-control" value={form.name} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Phone Number</label>
                    <input name="phone" maxLength={8} className="form-control" value={form.phone} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>License Number</label>
                    <input name="license_number" className="form-control" value={form.license_number} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Company Name</label>
                    <input name="company_name" className="form-control" value={form.company_name} onChange={handleChange} required />
                </div>

                {/* Rates - Updated Salary Structure */}
                <div className="form-group">
                    <label>Basic Salary</label>
                    <input type="number" step="0.01" name="basic_salary" className="form-control" value={form.basic_salary} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Office Hours OT Salary</label>
                    <input type="number" step="0.01" name="office_hours_ot" className="form-control" value={form.office_hours_ot} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>After Office OT Salary</label>
                    <input type="number" step="0.01" name="after_office_ot" className="form-control" value={form.after_office_ot} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday OT Salary</label>
                    <input type="number" step="0.01" name="holiday_ot" className="form-control" value={form.holiday_ot} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Account Status</label>
                    <Select 
                        options={statusOptions}
                        value={statusOptions.find(opt => opt.value === form.status)}
                        onChange={handleSelectChange}
                        classNamePrefix="react-select"
                    />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add py-2 fw-bold shadow-sm" disabled={loading} type="submit">
                        {loading ? "Saving Changes..." : "Update Driver Information"}
                    </button>
                    <button type="button" className="btn btn-light ms-2 py-2" onClick={() => navigate("/drivers")}>Cancel</button>
                </div>
            </form>
        </div>
    );
};

export default EditDriver;